exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-templates-blog-post-jsx": () => import("./../../../src/templates/blog-post.jsx" /* webpackChunkName: "component---src-templates-blog-post-jsx" */),
  "component---src-templates-cards-jsx": () => import("./../../../src/templates/cards.jsx" /* webpackChunkName: "component---src-templates-cards-jsx" */),
  "component---src-templates-longcards-jsx": () => import("./../../../src/templates/longcards.jsx" /* webpackChunkName: "component---src-templates-longcards-jsx" */)
}

